import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  ASSIGN_VENDOR_REMARKS_LIST,
  BOOKING_ASSIGN_TO_ME,
  CANCELLATION_REMARKS_FOR_VENDOR,
  GET_CHAUFFEURS_LIST,
  GET_VENDORS_LIST_DATA,
  SHOW_MODIFY_FIELDS,
  UPLOAD_CANCELATION_FILE_EMPTY,
} from '../../../../../../../store/actions';
import ConfirmBookingV2 from './ConfirmBookingV2';
import NotifyGolfCourse from '../Golf/NotifyGolfCourse';
import LoaderData from '../AirportTransfer/LoaderData';
import ModifyPlayer from './ModifyPlayer';
import ApprovalAction from './ApprovalAction';
import MarkAsComplete from './MarkAsComplete';
import CancelBooking from './CancelBooking';
import RejectBookingV2 from './DeclineBookingV2';
import RaiseDispute from './RaiseDispute';
import ShortNoticeCancel from './ShortNoticeCancel';
import NotifyCustomer from './NotifyCustomer';
import ModifyOption from './ModifyOption';
import SuggestCourse from './SuggestCourse';
import ModifySlot from './ModifySlot';
import ConfirmBooking from './ConfirmBooking';
import RejectBooking from './DeclineBooking';
import ModifySlotV2 from './ModifySlotV2';
import ModifyPlayerV2 from './ModifyPlayerV2';
import CancelledWithVendor from './CancelledWithVendor';

export default function GolfActionableModals({
  currentSelectedBooking,
  currentActiveBookingAction,
  setCurrentActiveBookingAction,
  isMultiSelectable,
  approvalRequestType,
  bookingDetails,
}) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATE ---------------------------- */
  const [isShowCancelBooking, setIsShowCancelBooking] = useState(false);
  const [isShowBookingConfirm, setIsShowBookingConfirm] = useState(false);
  const [isShowModifyPlayer, setIsShowModifyPlayer] = useState(false);
  const [isShowApprovalAction, setIsShowApprovalAction] = useState(false);
  const [isShowRejectionAction, setIsShowRejectionAction] = useState(false);
  const [isShowMarkAsComplete, setIsShowMarkAsComplete] = useState(false);
  const [IsShowDeclineBooking, setIsShowDeclineBooking] = useState(false);
  const [isShowRaiseDispute, setIsShowRaiseDispute] = useState(false);
  const [isShowShortNoticeCancel, setIsShowShortNoticeCancel] = useState(false);
  const [isShowGolfCourseNotify, setIsShowGolfCourseNotify] = useState(false);
  const [isShowCustomerNotify, setIsShowCustomerNotify] = useState(false);
  const [isShowModifyOptions, setIsShowModifyOptions] = useState(false);
  const [isShowSuggestCourse, setIsShowSuggestCourse] = useState(false);
  const [isShowModifySlot, setIsShowModifySlot] = useState(false);
  const [isCancelledWithVendor, setIsCancelledWithVendor] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { assignVendorRemarks, cancellationRemarks, carsListOfVendor, chauffeursList, vendorsList } = useSelector((state: any) => ({
    assignVendorRemarks: state?.AssignVendorRemarksList?.data,
    cancellationRemarks: state?.CancellationRemarksForVendor?.data,
    carsListOfVendor: state?.GetCarsListOfVendor?.data,
    chauffeursList: state?.GetChauffersList?.data,
    vendorsList: state?.GetVendorsListData?.data,
  }));

  useEffect(() => {
    if (cancellationRemarks === null) {
      dispatch({
        type: CANCELLATION_REMARKS_FOR_VENDOR,
        payload: {
          params: {
            entity: 'booking',
            isVendorCancel: true,
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    if (assignVendorRemarks === null) {
      dispatch({
        type: ASSIGN_VENDOR_REMARKS_LIST,
        payload: {
          params: {
            entity: 'vendor',
            isSystemPreferred: false,
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    if (currentSelectedBooking?.length === 1 && currentSelectedBooking?.[0]?.vendorId !== '') {
      dispatch({
        type: GET_CHAUFFEURS_LIST,
        payload: {
          params: {
            vendor_id: `${currentSelectedBooking?.[0]?.vendorId || ''}`,
            booking_id: currentSelectedBooking?.[0]?.id || ``,
          },
        },
      });
    }
  }, [currentSelectedBooking]);

  useEffect(() => {
    if (currentActiveBookingAction !== null) {
      console.log('notify-', currentActiveBookingAction);

      switch (currentActiveBookingAction) {
        case 'notify_vendor':
          setIsShowGolfCourseNotify(true);
          break;

        case 'notify_customer':
          setIsShowCustomerNotify(true);
          break;

        case `cancel_booking`:
          setIsShowCancelBooking(true);
          break;

        case 'vendor_accept':
          setIsShowBookingConfirm(true);
          break;

        case 'modify_booking':
          dispatch({
            type: SHOW_MODIFY_FIELDS,
            payload: {
              params: {
                booking_type: currentSelectedBooking?.[0]?.bookingType,
                booking_id: currentSelectedBooking?.[0]?.id,
              },
            },
          });
          setIsShowModifyOptions(true);
          break;

        case `approval`:
          setIsShowApprovalAction(true);
          break;

        case `reject`:
          setIsShowRejectionAction(true);
          break;

        case `complete_booking`:
          setIsShowMarkAsComplete(true);
          break;

        case `reject-slot`:
          setIsShowDeclineBooking(true);
          break;

        case `raise_a_dispute`:
          setIsShowRaiseDispute(true);
          break;

        case 'short_notice_cancel_booking':
          setIsShowShortNoticeCancel(true);
          break;

        case 'cancelled_with_vendor':
          setIsCancelledWithVendor(true);
          break;
      }
    }
  }, [currentActiveBookingAction]);

  const handleMofifyOption = (flag: string) => {
    switch (flag) {
      case 'MODIFY_PLAYER':
        setIsShowModifyPlayer(true);
        break;

      case 'SUGGEST_SLOT':
        setIsShowModifySlot(true);
        break;

      case 'SUGGEST_COURSE':
        setIsShowSuggestCourse(true);
        break;

      default:
        break;
    }
  };

  return (
    <>
      <LoaderData setCurrentActiveBookingAction={setCurrentActiveBookingAction} />

      {isShowGolfCourseNotify && (
        <NotifyGolfCourse
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowGolfCourseNotify(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowCustomerNotify && (
        <NotifyCustomer
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowCustomerNotify(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowRaiseDispute && (
        <RaiseDispute
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRaiseDispute(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowCancelBooking && (
        <CancelBooking
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowCancelBooking(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowModifyPlayer && bookingDetails?.bookingDetails?.booking_version === 'version_1' && (
        <ModifyPlayer
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowModifyPlayer(false);
          }}
          bookingDetails={bookingDetails}
          setIsShowModifyOptions={setIsShowModifyOptions}
        />
      )}

      {isShowModifyPlayer && bookingDetails?.bookingDetails?.booking_version === 'version_2' && (
        <ModifyPlayerV2
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowModifyPlayer(false);
          }}
          bookingDetails={bookingDetails}
          setIsShowModifyOptions={setIsShowModifyOptions}
        />
      )}

      {isShowSuggestCourse && (
        <SuggestCourse
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowSuggestCourse(false);
          }}
          setIsShowModifyOptions={setIsShowModifyOptions}
        />
      )}

      {isShowModifyOptions && (
        <ModifyOption
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowModifyOptions(false);
            setCurrentActiveBookingAction(null);
          }}
          handleMofifyOption={handleMofifyOption}
        />
      )}

      {isShowBookingConfirm && bookingDetails?.bookingDetails?.booking_version === 'version_2' && (
        <ConfirmBookingV2
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowBookingConfirm(false);
            setCurrentActiveBookingAction(null);
          }}
          bookingDetails={bookingDetails}
        />
      )}

      {isShowBookingConfirm && bookingDetails?.bookingDetails?.booking_version !== 'version_2' && (
        <ConfirmBooking
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowBookingConfirm(false);
            setCurrentActiveBookingAction(null);
          }}
          bookingDetails={bookingDetails}
        />
      )}

      {isShowShortNoticeCancel && (
        <ShortNoticeCancel
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowShortNoticeCancel(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowApprovalAction && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalAction(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalRequestType={approvalRequestType}
        />
      )}

      {isShowRejectionAction && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectionAction(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalRequestType={approvalRequestType}
        />
      )}

      {isShowMarkAsComplete && (
        <MarkAsComplete
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowMarkAsComplete(false);
            setCurrentActiveBookingAction(null);
          }}
          isMultiSelectable={isMultiSelectable ?? false}
        />
      )}

      {IsShowDeclineBooking && bookingDetails?.bookingDetails?.booking_version === 'version_2' && (
        <RejectBookingV2
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowDeclineBooking(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {IsShowDeclineBooking && bookingDetails?.bookingDetails?.booking_version !== 'version_2' && (
        <RejectBooking
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowDeclineBooking(false);
            setCurrentActiveBookingAction(null);
          }}
        />
      )}

      {isShowModifySlot && bookingDetails?.bookingDetails?.booking_version !== 'version_2' && (
        <ModifySlot
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowModifySlot(false);
            setCurrentActiveBookingAction(null);
          }}
          setIsShowModifyOptions={setIsShowModifyOptions}
        />
      )}

      {isShowModifySlot && bookingDetails?.bookingDetails?.booking_version === 'version_2' && (
        <ModifySlotV2
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowModifySlot(false);
            setCurrentActiveBookingAction(null);
          }}
          setIsShowModifyOptions={setIsShowModifyOptions}
        />
      )}

      {isCancelledWithVendor && (
        <CancelledWithVendor
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsCancelledWithVendor(false);
            setCurrentActiveBookingAction(null);
            dispatch({
              type: UPLOAD_CANCELATION_FILE_EMPTY,
            });
          }}
        />
      )}
    </>
  );
}
